import React, { useCallback, useEffect, useState } from 'react';
import { TextField, FormHelperText } from '@mui/material';

const TextInput = ({
  id,
  value = '',
  onChange,
  placeholder,
  maxLength,
  type = 'text',
  rows = 1,
  regex =/[\s\S]*/,
  ...props
}) => {
  const [length, setLength] = useState(value?.length);

  const handleChange = useCallback(
    (e) => {
      const newValue = e.target.value
        .slice(0, maxLength)
        .match(regex)
        ?.join('') || '';

      setLength(newValue.length);
      onChange(id, newValue);
    },
    [id, maxLength, regex, onChange]
  );

  useEffect(() => {
    setLength(value?.length);
  }, [value]);

  return (
    <>
      <TextField
        id={id}
        value={value}
        onChange={handleChange}
        placeholder={placeholder}
        required
        inputProps={{ maxLength }}
        fullWidth
        multiline={type === 'textarea'}
        rows={type === 'textarea' ? rows : undefined}
        variant="outlined"
        {...props}
      />
      {maxLength && (
  <FormHelperText
    sx={{
      textAlign: 'right',
      color: length >= maxLength - 15 ? 'error.main' : 'text.secondary',
    }}
  >
    {length}/{maxLength}
  </FormHelperText>
)}
    </>
  );
};

export default TextInput;
